import React from 'react';
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {SearchClearIconBox} from "./boxes/search-clear-icon/search-clear-icon.box";
import {SearchInputMobileBox} from "./boxes/search-input-mobile/search-input-mobile.box";
// import {SearchBoxMobileIconBox} from "./boxes/search-box-mobile-icon/search-box-mobile-icon.box";
import {SearchInputArea} from "../search-input-area/search-input-area";
import {CyClass} from "../../../../../common/cy-classes";
import {SearchIconBox} from '../search-input-pc/boxes/search-icon/search-icon.box';

interface SearchInputMobileComponentProps {
  isSearchOpenAlways?: boolean;
}

export const SearchInputMobileComponent = observer(
  class SearchInputMobileComponent extends OrbitComponent<SearchInputMobileComponentProps> {
    private _onResetSearchTextHandler = () => {
      this.services.gameSearch.search('');
      this.services.gameSearch.searchInputRef?.current?.focus();
    };

    private get _showResetSearchIcon(): boolean {
      return (this.services.gameSearch.currentSearchText || '').length > 0;
    }

    render() {
      const SearchIcon = this.services.theme.currentTheme.icons.searchIcon;
      return (
          <SearchInputMobileBox className={CyClass('cy-menu-item')}>
            <SearchIconBox>
                <SearchIcon size={2} />
            </SearchIconBox>
            <SearchClearIconBox className={CyClass('cy-clear-search-box-icon')} visible={this._showResetSearchIcon} onClick={this._onResetSearchTextHandler} />
            <SearchInputArea/>
          </SearchInputMobileBox>
      );
    }
  }
);
